module.exports = __webpack_public_path__ + "static/media/TV.eb5ef829.svg";